exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-detail div[data-v-9792f17c] {\n  border-bottom: 0.005208rem solid #ebeef5;\n  height: 0.15625rem;\n  margin-bottom: 0.078125rem;\n  display: flex;\n  justify-content: space-between;\n}", ""]);

// exports
